import { ASAMA_PERFORMANS_RAPOR_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const asamaPerformansRaporSorgula = (altSurecTipiId,stateId) => {
    return getRequest({ url: ASAMA_PERFORMANS_RAPOR_SORGULA + "?altSurecTipiId=" + altSurecTipiId + "&stateId=" +stateId });
}

export default asamaPerformansRaporSorgula;